import type { IconType } from "react-icons";

interface EmptyStateProps {
  /** Icon to display */
  icon: IconType;
  /** Title text */
  title: string;
  /** Description text */
  description: string;
}

/**
 * Generic empty state component
 * Used for empty trash, no results, etc.
 */
export function EmptyState({ icon: Icon, title, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-white py-12 text-center">
      <Icon className="h-12 w-12 text-gray-400" />
      <h3 className="mt-4 text-sm font-medium text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
    </div>
  );
}
